<template>
    <div>
        <h2>Linechart</h2>
        <div>
            <canvas id="linechart"></canvas>
        </div>
    </div>
</template>

<script>
import Chart from 'chart.js';

export default {
    name: 'LineChart',
    methods: {
        async createLinechart() {
            const result = await this.$get(this.$getSetting('paths.baseCms') + '/revenue');
            this.chartdata = result.chartdata;

            const canvasTag = document.getElementById('linechart');
            const config = {
                type: 'line',
                data: {
                    labels: this.chartdata[0].value,
                    datasets: [{
                        label: 'My First Dataset',
                        data: this.chartdata[0].value,
                        fill: false,
                        borderColor: 'rgb(75, 192, 192)',
                        tension: 0.1
                    }]
                }
            };

             new Chart(canvasTag, config);
        }

    },
    mounted() {
        this.createLinechart();
    }
};
</script>
